export default "__VITE_ASSET__DiTyqyxn__"